import './index.css';
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

// Create a root using the new React 18 API
const container = document.getElementById("root");
// TypeScript null check
if (!container) throw new Error("Root element not found");
const root = createRoot(container);
// Initial render
root.render(<React.StrictMode><App /></React.StrictMode>);